import { BrowserImage } from "@vibrant/image-browser";
import "./config.js";
import { Vibrant } from "@vibrant/core";
import { Vibrant as Vibrant2 } from "@vibrant/core";
Vibrant.DefaultOpts.ImageClass = BrowserImage;
export {
  Vibrant2 as Vibrant
};
//# sourceMappingURL=browser.js.map
